<div class="set-password-container">
  <div class="set-password-card">
    <div class="logo-header">
      <img [src]="logoPath" alt="Nevada Department of Education Logo">
    </div>
    <div class="horizontal-line"></div>
    
    
    
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <div class="form-content">
        <h1 class="page-title">Set a New Password</h1>
        <div class="text-field">
          <div class="field-label">
            <label for="password">New Password</label>
            <span class="required">*</span>
          </div>
          
          <div class="input-container">
            <input 
              [type]="showPassword ? 'text' : 'password'" 
              id="input_set-new-password_password"
              formControlName="password" 
              (input)="checkPasswordValidation()"
              placeholder="Enter New Password"
            >
                     <button 
  type="button"
  class="password-view" 
   id="btn_set-new-password_password-view"
  (click)="togglePasswordVisibility()"
  aria-label="Toggle password visibility">
  <span [ngClass]="{ 'pi-eye': showPassword, 'pi-eye-slash': !showPassword }" class="pi"></span>
</button>
          </div>
        </div>
        
        <div class="validation-list" id="set-new-password_validation-list" *ngIf="passwordForm.get('password')?.value && !allValidationsPass">
          <div class="validation-item" id="set-new-password_validation-item" [ngClass]="{'valid': validations.minLength}">
            Between 8 and 16 characters
          </div>
          <div class="validation-item"  id="set-new-password_validation-item" [ngClass]="{'valid': validations.uppercase}">
            At least one uppercase letter (A–Z)
          </div>
          <div class="validation-item"  id="set-new-password_validation-item" [ngClass]="{'valid': validations.lowercase}">
           At least one lowercase letter (a–z)
          </div>
          <div class="validation-item"  id="set-new-password_validation-item" [ngClass]="{'valid': validations.number}">
            At least one number (0–9)
          </div>
          <div class="validation-item"  id="set-new-password_validation-item" [ngClass]="{'valid': validations.specialChar}">
            At least one special character (e.g., ! @ # $ %)
          </div>
          <div class="validation-item"  id="set-new-password_validation-item" [ngClass]="{'valid': validations.noPersonalInfo}">
            Does not contain your first, middle, or last name
          </div>
          <div class="validation-item"  id="set-new-password_validation-item" [ngClass]="{'valid': validations.alphanumeric}">
            Does not contain spaces
          </div>
          <div class="validation-item"  id="set-new-password_validation-item" [ngClass]="{'valid': validations.noDictionaryWord}">
            Please select a credential type.
          </div>
        </div>
        
        <div class="text-field">
          <div class="field-label">
            <label for="confirmPassword">Confirm Password</label>
            <span class="required">*</span>
          </div>
          
          <div class="input-container">
            <input [ngClass]="!isSetNewPasswordValid ?'pointer' : 'no-pointer' "
              [type]="showConfirmPassword ? 'text' : 'password'" 
              id="input_set-new-password_confirmPassword"
              formControlName="confirmPassword" 
              placeholder="Confirm New Password"
            >
                       <button 
  type="button"
  class="password-view" 
   id="btn_set-new-password_password-view"
  (click)="toggleConfirmPasswordVisibility()"
  aria-label="Toggle password visibility">
  <span [ngClass]="{ 'pi-eye': showConfirmPassword, 'pi-eye-slash': !showConfirmPassword }" class="pi"></span>
</button>
          </div>
        </div>
        
        <button 
          type="submit" 
          class="submit-button"
           id="btn_set-new-password_submit-button"
          [disabled]="!passwordForm.valid || !allValidationsPass"
        >
          Set Password
        </button>
      </div>
    </form>
  </div>
</div>